import { render, staticRenderFns } from "./imprintContent.vue?vue&type=template&id=aa678e52&scoped=true"
import script from "./imprintContent.vue?vue&type=script&lang=js"
export * from "./imprintContent.vue?vue&type=script&lang=js"
import style0 from "./imprintContent.vue?vue&type=style&index=0&id=aa678e52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa678e52",
  null
  
)

export default component.exports